import { Shark, SmartModel, Utils } from "shark-mvc";
import moment from "moment";

class Picture extends SmartModel {
	constructor(data) {
		super();

		this.createdAt = "0000-00-00 00:00:00";
		this.createdByGuid = "";
		this.fileSize = 0;
		this.fileType = "";
		this.fileURL = "";
		this.galleryGuid = "";
		this.guid = "";
		this.name = "";
		this.status = 0;
		this.tags = [];
		this.type = "";
		this.updatedAt = "0000-00-00 00:00:00";
		this.updatedByGuid = "";

		this.__fileSize = "";

		if (data) {
			this.import(data);
		}
	}

	export () {
		const exportedData = this.__export();

		exportedData.createdAt = moment.utc(this.createdAt).format("YYYY-MM-DD HH:mm:ss");
		exportedData.updatedAt = moment.utc(this.updatedAt).format("YYYY-MM-DD HH:mm:ss");
		exportedData.tags = JSON.stringify(this.tags);

		return exportedData;
	}

	import(data, options) {
		this.__import(data, options);

		this.createdAt = moment.utc(data.createdAt).local();
		this.fileSize = parseInt(data.fileSize);
		this.status = parseInt(data.status);
		this.tags = Utils.parseJSON(data.tags);
		this.updatedAt = moment.utc(data.updatedAt).local();

		const mbValue = this.fileSize / Math.pow(1024,2);
		this.__fileSize = mbValue.toFixed(1);
	}
}

Shark.registerModel("Picture", Picture);

export default Picture;